import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";

import DesktopHeader from '../desktopHeader';
import ShoppingCartItemsList from "./shoppingCartItemsList";
import InstView from "../installation/instView";
import Analytics from './../../analytics';

import {
  setCameFromPage,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  toggleInstOpened,
  clickQuestionNo,
  toggleUserPopup,
  clearCart,
  changeMessageBoxState,
}
  from "../../actions/actionFunctions";

import ShoppingCart from "./shoppingCart";
import DepositDisclaimer from "./depositDisclaimer";
import PriceWorksheetView from "../priceWorksheet/priceWorksheetView";
import ShoppingCartTotalColumns from "./shoppingCartTotalColumns";
import ShoppingCartFooter from "./shoppingCartFooter";
import ShoppingCartCanvas from "./shoppingCartCanvas";
import NotInVisualizerView from "../selectionWindow/notInVisualizerView";
import ShoppingCartInstallationQuestion from "./shoppingCartInstallationQuestion";
import Quotes from "./quotes";
import HardcodedCanvasImage from "../visComponents/hardcodedCanvasImage";
import NoInternetOverlay from "../ui/noInternetOverlay";
import LoadingSpinner from "../ui/loadingSpinner";
import {togglePriceWorksheetOpened} from "../../actions/priceWorksheetActions";


class ShoppingCartDesktop extends ShoppingCart {

  static propTypes = {
    bvOpened: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.scartContent = null;
    this.state = {
      questionShown: false,
    };
    this.needToShowQuestionAgain = false;
  }

  componentDidMount() {
    if (!this.props.questionNoClicked) {
      this.scartContent.addEventListener('scroll', this.onContentScroll);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('body--materials');
    this.scartContent.removeEventListener('scroll', this.onContentScroll);
  }

  onContentScroll = () => {
    const questionShown = this.scartContent.scrollTop > 110;
    this.setState({
      questionShown
    });
    // console.log('this.props.questionNoClicked', this.props.questionNoClicked);
    if (questionShown && this.props.questionNoClicked) {
      this.needToShowQuestionAgain = true;
    }
    if (this.scartContent.scrollTop === 0 && this.needToShowQuestionAgain) {
      this.needToShowQuestionAgain = false;
      this.props.clickQuestionNo(false);
    }
  };

  handleNoClick = () => {
    Analytics.sendClickEvent("shopping-cart-desktop-no");
    this.setState({
      questionShown: true
    });
    this.props.clickQuestionNo(true);
  };

  openInstallationView = () => {
    Analytics.sendClickEvent("open-installation-view-from-cart");
    this.props.toggleInstOpened(true);
  };

  toggleUserPopup = () => {
    this.props.toggleUserPopup({
      userPopupOpened: true
    })
  };

  renderCanvasPosition = (hardcodedImage) => {
    if (this.props.visualizerIsChanging) {
      return (
        <div className={"dcart-canvas selection-main__image selection-main__image--" + document.kvConfig.visualizerType
          + " selection-main__image--"}>
          <LoadingSpinner/>
        </div>
      )
    }
    if (hardcodedImage) {
      return null
    }
    const {visualizerNotAvailable} = this.props;
    if (visualizerNotAvailable) {
      return <NotInVisualizerView isMobile={false}
                                  allVisualizerNotAvailable={true}
                                  activeFeature={null}/>
    }
    return <ShoppingCartCanvas/>
  };

  render() {
    const {fabricatorData, priceWorksheetOpened} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    const allowInstallations = fabricatorSettings.addLaborCustomer
      || (document.kvConfig.isBackend && fabricatorSettings.addLaborInstaller);
    const showInstallations = allowInstallations && this.props.instList.length
      && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep >= 2)) // tutorial
      && this.props.instList.some((instGroup) => instGroup.services.some(service => !service.autoAddWithProduct));
    // const showPriceWorksheet = fabricatorSettings.priceWorksheetEnabled; //TODO[Artem] change after BE done
    const showPriceWorksheet = !(this.props.discountsReceived && !this.props.discountSections.length)
      && document.kvConfig.isBackend;

    let recentlyItems = [];
    let showRecentlyViewedItems = fabricatorSettings.showRecentlyViewedItems;
    if (showRecentlyViewedItems) {
      recentlyItems = this.getRecentlyViewedItems();
      showRecentlyViewedItems = recentlyItems.length > 0;
    }

    const cartItemsLength = this.props.cartItems.length;
    const {showAdvancedQuoting, staticCanvasImage} = this.props;

    return (
      <div className="dcart">
        <DesktopHeader uploadsAndNotes={false}/>
        <div className={"dcart-main" + (showRecentlyViewedItems ? " dcart-main--with-recently" : "")}>
          <div className={"dcart-main__left flex flex--column height-100"}>
            <NoInternetOverlay/>
            <HardcodedCanvasImage/>
            {this.renderCanvasPosition(staticCanvasImage)}
            {priceWorksheetOpened ? null : (
              <div className="dcart-rooms">
                <Quotes/>
              </div>
            )}
          </div>
          <div className="dcart-main__right">
          <div className={"dcart-content" + (!cartItemsLength && !showAdvancedQuoting ? " dcart-content--empty" : "")
            + (showAdvancedQuoting ? " dcart-content--advanced" : "")
            + (fabricatorSettings.showPricing && !showRecentlyViewedItems ? " dcart-content--with-total" : "")}
                 ref={(el) => this.scartContent = el}>
              {showInstallations
                ? <ShoppingCartInstallationQuestion questionNoClicked={this.props.questionNoClicked}
                                                    handleNoClick={this.handleNoClick}
                                                    openInstallationView={this.openInstallationView}/>
                : null}
              <ShoppingCartItemsList/>
              {cartItemsLength && fabricatorSettings.depositDisclaimer && fabricatorSettings.enableDisclaimer
              && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep === 4))
                ? <DepositDisclaimer/>
                : null}
            </div>
            {showInstallations ? <InstView/> : null}
            {showPriceWorksheet ? <PriceWorksheetView/> : null}
            {fabricatorSettings.showPricing && !showRecentlyViewedItems && !fabricatorData.hidePricesFromUser ? (
              <div className="dcart-total">
                <div className="dcart-total__content"><ShoppingCartTotalColumns/></div>
              </div>
            ) : null}
          </div>
        </div>
        <ShoppingCartFooter showRecentlyViewedItems={showRecentlyViewedItems} recentlyItems={recentlyItems}/>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {staticCanvasImage, bvOpened} = store.bathroomVisualizerState;
  const {visualizerIsChanging} = store.serverState;
  const {priceWorksheetOpened, financePaymentType, discountSections, discountsReceived} = store.priceWorksheetState;

  return {
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    bvOpened,
    staticCanvasImage,
    cameFromPage: store.cartState.cameFromPage,
    selectionGroup: store.selectionState.selectionGroup,
    questionNoClicked: store.cartState.questionNoClicked,
    fabricatorData: store.fabricatorState,
    recentlyViewedItems: store.cartState.recentlyViewedItems,
    visualizerNotAvailable: store.initialFlowState.visualizerNotAvailable,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    unlockCalculationsStep: store.unlockCalculationsState.unlockCalculationsStep,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    visualizerIsChanging,
    priceWorksheetOpened,
    financePaymentType,
    discountSections,
    discountsReceived,
  };
};

export default connect(mapStateToProps, {
  setCameFromPage,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  toggleInstOpened,
  clickQuestionNo,
  toggleUserPopup,
  clearCart,
  changeMessageBoxState,
  togglePriceWorksheetOpened,
})(ShoppingCartDesktop);
